(function () {
  function initCarousel(root) {
    var swiperEl = root.querySelector('.vc-swiper');
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-carousel-item]'));
    var dotsContainer = root.querySelector('[data-carousel-dots]');
    var prevBtn = root.querySelector('[data-carousel-prev]');
    var nextBtn = root.querySelector('[data-carousel-next]');

    if (!swiperEl || items.length === 0 || typeof window.Swiper === 'undefined') return;

    var cardsDesktop = parseInt(root.getAttribute('data-cards-desktop'), 10) || 5;
    var cardsTablet = parseInt(root.getAttribute('data-cards-tablet'), 10) || 3;
    var spacingDesktop = parseInt(root.getAttribute('data-spacing-desktop'), 10) || 16;
    var spacingMobile = parseInt(root.getAttribute('data-spacing-mobile'), 10) || 12;

    // Loop only when there are enough slides to fill the largest view —
    // with fewer slides, Swiper's loop duplication misbehaves and dragging
    // jumps or stalls.
    var maxPerView = Math.max(cardsDesktop, cardsTablet);
    var enableLoop = items.length > maxPerView;

    var swiper = new window.Swiper(swiperEl, {
      slidesPerView: 1,
      spaceBetween: spacingMobile,
      speed: 350,
      loop: enableLoop,
      grabCursor: true,
      simulateTouch: true,
      allowTouchMove: true,
      // Playing cards get the swiper-no-swiping class (see below) so drags
      // on the native controls — the seek bar especially — never fling
      // the track. Paused cards remain draggable.
      noSwiping: true,
      // Ignore sub-10px movements so ordinary clicks (with a little hand
      // jitter) never register as swipes — moving the track in loop mode
      // relocates slides and resets playing videos.
      threshold: 10,
      // Breakpoints let Swiper manage slide sizing itself. Manually mutating
      // params on resize corrupted loop state and broke drag positioning.
      breakpoints: {
        768: {
          slidesPerView: Math.min(cardsTablet, items.length),
          spaceBetween: spacingDesktop
        },
        1024: {
          slidesPerView: Math.min(cardsDesktop, items.length),
          spaceBetween: spacingDesktop
        }
      },
      // Native Swiper nav/pagination — no custom index math anywhere, so
      // loop mode and the bullets always agree.
      navigation: prevBtn && nextBtn ? { prevEl: prevBtn, nextEl: nextBtn } : false,
      pagination: dotsContainer ? { el: dotsContainer, clickable: true } : false
    });

    // Swiper's constructor can return undefined or fail to set .params if the
    // bundle CSS isn't loaded yet or the swiper element has zero size. Bail
    // out so callbacks from a half-built instance don't crash.
    if (!swiper || !swiper.params) {
      console.warn('Video carousel: Swiper failed to initialize.');
      return;
    }

    // Video play/pause (one-at-a-time)
    function pauseAllExcept(activeVideo) {
      items.forEach(function (item) {
        var v = item.querySelector('video');
        if (v && v !== activeVideo) {
          v.pause();
        }
      });
    }

    items.forEach(function (item) {
      var video = item.querySelector('video');
      if (!video) return;

      // No native chrome until playback starts — the overlay owns the
      // paused state.
      video.controls = false;

      // While playing, clicks on the card surface are swallowed in the
      // capture phase — nothing downstream (theme scripts, bubbling
      // handlers) gets a chance to pause it. Clicks in the bottom control
      // strip pass through so the native pause button works as expected.
      item.addEventListener('click', function (e) {
        if (!item.classList.contains('is-playing')) return;
        var rect = item.getBoundingClientRect();
        var inControlStrip = e.clientY - rect.top > rect.height - 60;
        if (inControlStrip) return;
        e.preventDefault();
        e.stopPropagation();
      }, true);

      // Keep the is-playing class in sync with actual playback state, so the
      // overlay's pointer-events: none kicks in and native controls work.
      // Controls are added/removed alongside it so they only ever show
      // during active playback.
      video.addEventListener('play', function () {
        pauseAllExcept(video);
        video.controls = true;
        item.classList.add('is-playing');
        // Ignore swipes starting on this card while it's playing — seeking
        // on the native track must not move the carousel (a swipe relocates
        // slides in loop mode, which detaches the <video> and resets it).
        item.classList.add('swiper-no-swiping');
      });
      video.addEventListener('pause', function () {
        video.controls = false;
        item.classList.remove('is-playing');
        // Draggable again once controls are gone.
        item.classList.remove('swiper-no-swiping');
      });
      video.addEventListener('ended', function () {
        // Belt-and-braces loop: normally the native `loop` attribute handles
        // this and 'ended' never fires. If it ever does fire (attribute
        // stripped, etc.), restart manually so videos always loop.
        video.currentTime = 0;
        var p = video.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      });
    });

    // Play handling is delegated so it also covers Swiper's loop-cloned
    // slides, whose buttons have no direct listeners.
    swiperEl.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-video-toggle]') : null;
      if (!btn) return;
      var scopeItem = btn.closest('[data-carousel-item]');
      var vid = scopeItem ? scopeItem.querySelector('video') : null;
      if (!vid) return;
      pauseAllExcept(vid);
      // Videos render muted (autoplay-policy safe), but this click is a
      // user gesture, so audio is allowed — unmute as playback starts.
      vid.muted = false;
      vid.play();
      scopeItem.classList.add('is-playing');
      scopeItem.classList.add('swiper-no-swiping');
    });
  }

  function init() {
    if (typeof window.Swiper === 'undefined') {
      // Swiper not yet loaded — wait for it.
      var wait = setInterval(function () {
        if (typeof window.Swiper !== 'undefined') {
          clearInterval(wait);
          initAll();
        }
      }, 50);
      return;
    }
    initAll();
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-video-carousel]');
    roots.forEach(function (root) {
      initCarousel(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
